class ServiceCharge {
    charge_id: string
    payment_file_path: string
}

export class Installation {
    uuid: string
    user_id: number
    charge: ServiceCharge
    sd_id: number
    
    constructor(uuid: string, user_id: number, sd_id: number) {
        this.uuid = uuid;
        this.user_id = user_id;
        this.sd_id = sd_id;
    }

    toPrimitive() {
        return {
            uuid: this.uuid,
            user_id: this.user_id,
            sd_id: this.sd_id
        };
    }
}

export interface PaymentPopup {
    show(): Promise<any | null>
    close(file)
}